import 'react-table/react-table.css';
import 'react-datepicker/dist/react-datepicker.css';
import './index.css';

import React from 'react';
import ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import { Route, Switch, Redirect } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';

import Login from './components/login';
import Terms from './components/login/terms';
import Privacy from './components/login/privacy';
import Layout from './components/layout';
import config from './config';
import { store, history } from './store';

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      store.getState().session.user ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: config.basePath + '/login',
            state: { from: props.location }
          }}
        />
      )
    }
  />
);

class App extends React.Component {
  render() {
    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <Switch>
            <Route path={config.basePath + '/login'} component={Login} />
            <Route path={config.basePath + '/terms'} component={Terms} />
            <Route path={config.basePath + '/privacy'} component={Privacy} />
            <PrivateRoute path={config.basePath} component={Layout} />
            <PrivateRoute path='/' component={Layout} />
          </Switch>
        </ConnectedRouter>
      </Provider>
    );
  }
}

ReactDOM.render(<App />, document.getElementById('app-mount'));
